<script lang="ts">
  import GoogleAdSense from "$components/adSense/googleAdSense.svelte";
  import { t } from "$lib/i18n/translations";
  import { page } from "$app/stores";
  import { isMobile } from "$lib/device";
  import locale from "$lib/i18n/locale";
  import { capitalize } from "$lib/util";
  $: lang = $locale;
  const typeList = [
    "video",
    "photo",
    "reels",
    "story",
    "post",
    "igtv",
    "highlights"
  ];

  
</script>

<!-- 底部 -->
<footer class="w-full">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex flex-col justify-center px-[16px] max-mobile:mb-0"
  >
    <div
      class="grid grid-cols-4 mt-[60px] max-mobile:grid-cols-1 max-mobile:text-center max-mobile:mt-[28px]"
    >
      {#each typeList as type}
        <a
          class="text-[14px] font-bold mb-[48px] max-mobile:mb-[28px]"
          href="/{lang}/instagram-{type}-downloader"
          target="_self"
        >
          {$t("general.footer.button", { value: capitalize(type) })}
        </a>
      {/each}
    </div>
    <hr class="text-[#848d9533] text-[14px]" />
    <div
      class="my-[40px] grid grid-cols-4 max-mobile:grid-cols-1 max-mobile:text-center max-mobile:my-[28px] max-mobile:gap-[28px]"
    >
      <a class="" href="/{lang}/how-to-download-instagram-photos" target="_self">
        {$t("general.footer.photo")}
      </a>
      <a class="" href="/{lang}/how-to-download-instagram-videos" target="_self">
        {$t("general.footer.videos")}
      </a>
    </div>

    <hr class="text-[#848d9533]" />
    <div
      class="my-[40px] grid grid-cols-8 text-[14px] text-[#9D9D9D] max-mobile:grid-cols-1 max-mobile:text-center max-mobile:my-[28px] max-mobile:my-[28px] max-mobile:gap-[28px]"
    >
      <a
        class=" col-span-2 max-mobile:col-span-1"
        href="/{lang}"
        target="_self"
      >
        {$t("general.footer.reserved", { value: "InstaTube" })}
      </a>
      <a class="" href="/{lang}/about" target="_self">
        {$t("general.footer.about")}
      </a>
      <a class="" href="/{lang}/privacyPolicy" target="_self">
        {$t("general.footer.policy")}
      </a>
    </div>
  </div>
  {#if $isMobile}
    <!-- 广告 -->
    <div class="w-full" style="margin-bottom: env(safe-area-inset-bottom, 0px);">
      <GoogleAdSense type="crosswise"/>
    </div>
  {/if}
</footer>